import * as React from "react"
import injectSheet from "react-jss"
import compose from "recompose/compose"
import defaultProps from "recompose/defaultProps"
import { color } from "@xingternal/360-styles/helpers"

const styles = {
  group: {
    composes: "flex",
    flexFlow: ({ direction }) => direction === "column" && "column",
    "&:not(:last-child)": {
      borderBottom: ({ direction }) =>
        direction === "row" && `1px solid ${color("gray-15")}`,
    },
  },
  item: {
    composes: "flex-auto flex",
    flexBasis: ({ direction }) => direction === "row" && 100,
    "&:last-child": {
      borderRadius: ({ direction }) => direction === "column" && "0 0 4px 4px",
    },
    "&:not(:last-child)": {
      borderRight: ({ direction }) =>
        direction === "row" && `1px solid ${color("gray-15")}`,
      borderBottom: ({ direction }) =>
        direction === "column" && `1px solid ${color("gray-15")}`,
    },
  },
}

const enhance = compose(
  defaultProps({
    direction: "row",
  }),
  injectSheet(styles),
)

const KpiGroup = ({ children, classes, direction }) => (
  <div className={classes.group}>
    {React.Children.map(children, child => (
      <div className={classes.item}>
        {React.cloneElement(child, { direction })}
      </div>
    ))}
  </div>
)

export const EnhancedKpiGroup = enhance(KpiGroup)
export default KpiGroup
